<template>
    <div class="content">

        <toolbar v-bind:selection="toolbar" title="Alimentar colmenar" />

        <feedNew v-bind:idcolmenar="idcolmenar" />

    </div>


</template>

<script>
import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"
import feedNew from "@/components/FeedNew"

export default {

    name: 'alimentar-nueva',
    components: {
        toolbar,
        feedNew,
    },
    data() {
        return {
            toolbar: {
                return: '0'
            },
             idcolmenar: this.$route.params.idcolmenar,

        }
    },
    created() {
        auth.getUserLogged()
    }

};


</script>
